export const tinkRed = {
  100: '#FEF6F6',
  200: '#FCEDEC',
  300: '#FBDDDB',
  400: '#F8CBC8',
  500: '#F7BBB7',
  600: '#F4A9A4',
  700: '#EA544A',
  800: '#BB2B21',
  900: '#660A04',
};
